/**
 * ag-grid-facets
 */

import { Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
// Module styles

const FacetsGroup = ({ values, facet, closed = false }) => {
  const [displayValues, setDisplayValues] = useState([]);
  const [viewAll, setViewAll] = useState(false);
  const [isClosed, setIsClosed] = useState(closed);

  useEffect(() => {
    setIsClosed(closed);
  }, [closed]);

  useEffect(() => {
    const entryValues = values.filter((x) => x !== null);
    const firstValues = [...entryValues].splice(0, 5);
    setDisplayValues(viewAll ? entryValues : firstValues);
  }, [values]);

  const toggleViewAllFacets = () => {
    if (!viewAll) {
      setDisplayValues(values);
    } else {
      const newValues = [...values.filter((x) => x !== null)].splice(0, 5);
      setDisplayValues(newValues);
    }
    setViewAll(!viewAll);
  };

  const toggleAccordion = () => {
    setIsClosed(!isClosed);
  };

  return (
    <Fragment>
      <span
        className={`ag-grid-facets__group-title ${isClosed ? 'closed' : ''}`}
        tabIndex={0}
        onClick={toggleAccordion}
        onKeyPress={toggleAccordion}
      >
        {facet.label}
      </span>
      <li
        className={`ag-grid-facets__group ${facet.active ? 'active' : ''} ${
          isClosed ? 'closed' : ''
        }`}
      >
        <ul>
          {displayValues}
          {values.filter((x) => x !== null).length > 5 && (
            <li
              className={`ag-grid-facets__view-all`}
              tabIndex={0}
              onClick={toggleViewAllFacets}
              onKeyPress={toggleViewAllFacets}
            >
              {viewAll ? Drupal.t(`View Less`) : Drupal.t(`View All`)}
            </li>
          )}
        </ul>
      </li>
    </Fragment>
  );
};

export default FacetsGroup;
